import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from 'actions/chat';
import * as surveyActions from 'actions/chat/interactiveSurvey';
import * as webRTCActions from 'actions/chat/webrtc';
import * as fileUpload from 'actions/chat/fileUpload';
import Chat from 'components/chat/Chat';
import configuration from 'config';
import { CHAT_MODAL } from 'actions/chat';

export default connect(
  state => {
    let videoDevices = state.chat.webrtc.devices.filter(d => d.kind === 'videoInput'),
        { clientConfiguration } = state.chat.main;

    return {
      queueProperties: state.chat.main.queueProperties,
      preferedVideoMode: clientConfiguration.preferedVideoMode,
      isMobile: state.app.isMobile,
      connectionId: state.chat.main.connectionId,
      ended: state.chat.main.ended,
      webRTCStarted: state.chat.webrtc.started,
      webRTCMode: state.chat.webrtc.mode,
      overrittenMailTranscriptLabel: state.chat.main.overrittenMailTranscriptLabel,
      allowedWebRTCFeatures: clientConfiguration.allowedWebRTCFeatures,
      mailTranscriptSent: state.chat.main.mailTranscriptSent,
      agentTyping: state.chat.main.agentTyping,
      messageGroupingTreshold: clientConfiguration.messageGroupingTreshold,
      userIsTypingTimeout: clientConfiguration.userIsTypingTimeout,
      interactiveSurveyEnabled: clientConfiguration.interactiveSurveyEnabled,
      interactiveSurveyRetrieved: !!state.chat.interactiveSurvey.surveyInformation,
      videoFullscreen: clientConfiguration.forceFullScreenVideo,
      startVideoImmediately: clientConfiguration.startVideoImmediately,
      messages: state.chat.main.messages,
      surveyCode: state.chat.main.satisfactionSurveyCode,
      agentSupportsWebRTC: state.chat.webrtc.supportedByAgent,
      chooseCamera: clientConfiguration.chooseCamera
        && videoDevices.some(d => d.label.indexOf('back') !== -1)
        && videoDevices.some(d => d.label.indexOf('front') !== -1),
      chosenCamera: state.chat.webrtc.chosenCamera,
      fileUploadEnabled: state.chat.main.queueProperties.agentCanReceiveFiles,
      fileUploadProgress: state.chat.fileUpload.fileUploadProgress
        && state.chat.fileUpload.fileUploadProgress.toJS(),
      modal: state.chat.main.modal,
      receivedImageBeingShown:
        (state.chat.main.imageBeingShown && `data:image/png;base64, ${state.chat.main.images.get(state.chat.main.imageBeingShown)}`) ||
        (state.chat.fileUpload.receivedImageBeingShown
          && state.chat.fileUpload.receivedImages.get(state.chat.fileUpload.receivedImageBeingShown)),
    };
  },
  dispatch => bindActionCreators({
    onGetInteractiveSurveyInformation: surveyActions.getInformation,
    onStartWebRTC: webRTCActions.start,
    onStartChooseCamera: webRTCActions.startChooseCamera,
    onStartFileUpload: fileUpload.start,
    onModalClose: modal => {
      switch (modal) {
        case CHAT_MODAL.chooseCamera:
          return webRTCActions.cancelChooseCamera();
        case CHAT_MODAL.fileUpload:
          return fileUpload.minimize();
        default:
          return { type: actions.CLOSE_MODAL };
      }
    },
    onCancelImageView: () => {
      fileUpload.cancelImageView();
      return actions.closeImage();
    }
  }, dispatch),
  null,
  { withRef: true }
)(Chat);



// WEBPACK FOOTER //
// ./containers/chat/Chat.js